const MONTHS = {
    jan: 0,
    feb: 1,
    mar: 2,
    apr: 3,
    may: 4,
    jun: 5,
    jul: 6,
    aug: 7,
    sep: 8,
    oct: 9,
    nov: 10,
    dec: 11,
}

function parseDisplayDate(val) {
    const m = /^([A-Za-z]{3})\/(\d{1,2})\/(\d{4})\s+(\d{1,2}):(\d{2})\s*(am|pm)/i.exec(
        String(val).trim()
    )
    if (!m) return 0
    const month = MONTHS[m[1].toLowerCase()]
    if (month == null) return 0
    let hour = Number(m[4])
    const pm = m[6].toLowerCase() === 'pm'
    if (hour === 12) hour = pm ? 12 : 0
    else if (pm) hour += 12
    const ms = new Date(
        Number(m[3]),
        month,
        Number(m[2]),
        hour,
        Number(m[5])
    ).getTime()
    return Number.isNaN(ms) ? 0 : Math.floor(ms / 1000)
}

export function createdOnToSeconds(val) {
    if (val == null || val === '') return 0
    if (typeof val.toMillis === 'function') {
        const ms = val.toMillis()
        return Number.isFinite(ms) && ms > 0 ? Math.floor(ms / 1000) : 0
    }
    if (val instanceof Date) {
        const ms = val.getTime()
        return Number.isFinite(ms) && ms > 0 ? Math.floor(ms / 1000) : 0
    }
    if (typeof val === 'number') {
        if (!Number.isFinite(val) || val <= 0) return 0
        return val > 1e12 ? Math.floor(val / 1000) : val
    }
    if (typeof val === 'string') {
        const display = parseDisplayDate(val)
        if (display) return display
        const n = Date.parse(val)
        return Number.isNaN(n) || n <= 0 ? 0 : Math.floor(n / 1000)
    }
    const s = val.seconds ?? val._seconds
    const n = typeof s === 'string' ? Number(s) : s
    if (typeof n === 'number' && Number.isFinite(n) && n > 0) {
        return n > 1e12 ? Math.floor(n / 1000) : n
    }
    return 0
}

export function formatBoardDate(val) {
    const s = createdOnToSeconds(val)
    if (!s) return ''
    const d = new Date(s * 1000)
    const formattedDate = d.toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
    })
    const formattedTime = d.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
    })
    return `${formattedDate.replace(/, /g, '/')} ${formattedTime.toLowerCase()}`
}

export function compareByCreatedOnAsc(a, b) {
    return createdOnToSeconds(a.createdOn) - createdOnToSeconds(b.createdOn)
}

export function sortByCreatedOnAsc(items) {
    return [...(items || [])].sort(compareByCreatedOnAsc)
}
